import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const SegGraphics = () => {

  const servicesFaqData = [
    {
        question: "What are SEG graphics, and how are they used?",
        answer: "SEG (Silicone Edge Graphics) are high-resolution fabric graphics finished with a thin silicone strip sewn along the edges. This strip fits into a frame's recessed groove, creating a taut, frameless appearance. SEG graphics are used in retail, trade show booths, backlit displays, and interior décor to provide seamless and vibrant visuals."
    },
    {
        question: "What materials are used for SEG graphics fabric printing?",
        answer: "We use premium, wrinkle-resistant polyester fabrics designed specifically for SEG applications. These fabrics provide excellent colour reproduction and are durable for long-term use. They are suitable for both front-lit and backlit displays."
    },
    {
        question: "Can Printingy handle bulk orders for SEG graphics printing?",
        answer: "Yes, Printingy specialises in bulk SEG graphic printing, offering cost-effective solutions for large-scale projects. We ensure consistent quality and timely delivery, making us ideal for businesses needing multiple graphics for nationwide rollouts or large events."
    },
    {
        question: "What customisation options are available for SEG graphics?",
        answer: "Our custom SEG graphics fabric printing services allow you to choose various sizes, shapes, and finishing options. You can provide your designs or work with our team to create graphics that align with your branding and messaging."
    },
    {
        question: "How do I install SEG graphics?",
        answer: "SEG graphics are designed for easy installation. The silicone beading sewn around the edges of the fabric slides into the grooves of a compatible frame system, creating a smooth, frameless appearance without visible hardware."
    },
    {
        question: "Are SEG graphics suitable for backlit displays?",
        answer: "Absolutely. SEG fabrics are ideal for backlit applications because they diffuse light evenly. Our SEG Graphics Fabric Printing ensures high-resolution images that look stunning when illuminated from behind."
    },
    {
        question: "What industries benefit from SEG graphics printing services?",
        answer: "Industries such as retail, hospitality, exhibitions, corporate environments, and interior design benefit from Fabric & SEG Graphics Printing. SEG graphics are used for storefront displays, trade show booths, corporate branding, and decorative wall installations."
    },
    {
        question: "How durable are SEG graphics?",
        answer: "SEG graphics printed on high-quality fabrics are durable and designed for repeated use. They are resistant to wrinkling and can be folded or rolled for easy transport and storage. The fabrics are also washable, maintaining their appearance over time."
    },
    {
        question: "What is the turnaround time for bulk SEG graphics printing?",
        answer: "Turnaround times depend on the size and complexity of the order. However, we prioritise efficiency and deliver bulk orders within a few business days. We will provide a clear timeline upon order confirmation."
    },
    {
        question: "How do I place an order for SEG graphics printing?",
        answer: "To place an order, visit our website and select your desired specifications for printing of SEG graphics. Upload your design files or consult with our team for design assistance. We will guide you through the process from proofing to final delivery."
    }
  ];
  const [pageTitle, setPageTitle] = useState('Printing of SEG Graphics');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom SEG Graphics Printing Services for Displays"
  description="Professional printing of SEG graphics and fabric displays. Bulk SEG graphics fabric printing, custom silicone edge graphics for events and branding."
  keywords="Printing of SEG Graphics,
SEG Graphic Printing,
SEG Graphics Fabric Printing,
Fabric & SEG Graphics Printing"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of SEG Graphics </h1>
              <h2 className="text-muted">
              Custom SEG graphics fabric printing for stunning displays
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Silicone Edge Graphics (SEG) are high-resolution fabric graphics with a thin silicone beading sewn around the edges, allowing easy installation into frames and displays. Printingy specialises in SEG graphics, providing high-quality SEG graphic printing for businesses, events, and trade shows.</p>
          <p>Our SEG Graphics Fabric Printing services deliver vibrant colours, sharp details, and seamless visuals, perfect for backlit displays, retail environments, and exhibition stands. With Fabric & SEG Graphics Printing, we ensure your branding and messaging stand out with professional-quality graphics that are easy to install and replace.</p>
          <p>Whether for large-scale promotions or custom displays, Printingy offers bulk printing solutions that combine advanced technology with premium fabrics to meet your needs.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable SEG Graphics Printing Solutions</h2>
                <h3 className="large-hed">High-quality, vibrant, and custom SEG graphics for impactful displays</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert printing of SEG graphics for retail, events, and exhibitions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional seg graphic printing with sharp, high-resolution imagery.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk SEG Graphics Fabric Printing for cost-effective large-scale projects.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Customisable solutions with various sizes and finishing options.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology ensures colour accuracy and consistency.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Easy installation and replacement with silicone edge beading.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable, wrinkle-resistant fabrics for long-lasting use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and custom orders.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/seggraphics.jpg" // Path relative to the public folder
                  alt="SEG graphics fabric printing for displays"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium SEG Graphics Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your SEG graphics printing needs</h3>
            <p>Printingy combines state-of-the-art printing technology with high-quality fabrics to deliver exceptional SEG Graphics Fabric Printing services. Our Fabric & SEG Graphics Printing ensures that your displays have vibrant colours, crisp details, and a seamless appearance, enhancing the visual impact of your messaging.</p>
            <p>We understand the importance of timely delivery, especially for events and promotions. Our efficient production process guarantees quick turnaround times for bulk orders without compromising quality.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default SegGraphics;
